<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: chenw wchen@lingshi.com
 * @LastEditTime: 2025-03-29 09:18:21
 * @Description: drawer组件
-->
<template>
  <el-drawer
    ref="customDrawer"
    :class="{ 'ls-custom-double-drawer-component': appendToBody }"
    :title="title"
    :visible.sync="show"
    :size="drawerWidth"
    :custom-class="customClass"
    :wrapperClosable="false"
    :modal-append-to-body="modalAppendToBody"
    :append-to-body="true"
    :modal="modal"
    :direction="direction"
    :show-close="showClose"
    @close="close"
    @opened="opened"
    v-drawer-close="overlayClose ? close : false"
  >
    <template slot="title">
      <div class="flex-1">
        <slot name="title">{{ title }}</slot>
        <el-tooltip v-if="tooltipShow" placement="bottom-start">
          <span slot="content">
            <div v-html="tooltipContent"></div>
          </span>
          <i class="el-icon-question text-[16px] text-[#c8c9cc]"></i>
        </el-tooltip>
      </div>
    </template>
    <div class="flex-1 overflow-auto relative">
      <CustomLoading :visible="drawerLoading" />
      <slot name="content">默认内容</slot>
    </div>
    <slot name="footer">
      <div v-if="hasCancelBtn || hasConfirmBtn" class="drawer-footer">
        <ls-button
          v-if="hasCancelBtn"
          :disabled="cancelDisabled"
          :loading="cancelLoading"
          @click="cancel"
        >
          {{ cancelText }}
        </ls-button>
        <ls-button
          v-if="hasConfirmBtn"
          type="primary"
          :loading="confirmLoading"
          :disabled="confirmDisabled"
          @click="confirm"
          v-click-tracking="confirmTrackData"
        >
          {{ confirmText }}
        </ls-button>
      </div>
    </slot>
  </el-drawer>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsDrawer',
  componentName: 'LsDrawer',
  mixins: [mixin],
  props: {
    // 弹窗开关
    visible: {
      type: Boolean,
      default: false,
    },
    // 弹窗标题
    title: {
      type: String,
      default: '提示'
    },
    //提示内容
    tooltipContent: {
      type: String,
      default: " ",
    },
    //是否展示提示
    tooltipShow: {
      type: Boolean,
      default: false,
    },
    // 宽度，支持百分比和数字以及string类型的数字
    width: {
      type: [String, Number],
      default: "660",
    },
    //是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {
      type: Boolean,
      default: true,
    },
    // 自定义dialog类名
    customClass: {
      type: String,
      default: ''
    },
    //是否显示取消按钮
    hasCancelBtn: {
      type: Boolean,
      default: true,
    },
    //是否显示确定按钮
    hasConfirmBtn: {
      type: Boolean,
      default: true,
    },
    // 是否禁用取消按钮
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    // 是否禁用确定按钮
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    // 取消按钮loading
    cancelLoading: {
      type: Boolean,
      default: false,
    },
    // 确定按钮loading
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    //是否点遮罩层关闭
    overlayClose: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Drawer 的父元素上
    modalAppendToBody: {
      type: [Boolean],
      default: true,
    },
    // 是否展示遮罩
    modal: {
      type: [Boolean],
      default: true,
    },
    confirmTrackData: {
      // 确定按钮埋点数据
      type: [Object, String],
      default: () => null,
    },
    // 弹窗内容loading
    drawerLoading: {
      type: [Boolean],
      default: false,
    },
    // 弹窗打开的方向
    direction: {
      type: [String],
      default: 'rtl',
    }
  },
  data () {
    return {
      
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
    drawerWidth(){
      if (typeof this.width === 'number') {
        return this.width
      }

      if (typeof this.width === 'string' && this.width.includes('%')) {
        return this.width
      } else {
        return Number(this.width)
      }
    }
  },
  methods: {
    close() {
      this.show = false;
    },
    opened(){
      this.$emit("opened");
    },
    cancel(e) {
      this.$emit("cancel");
    },
    confirm(e) {
      this.$emit("confirm");
    },
    
  }
}

</script>

<style lang="less">
@import url('./index.less');
</style>